<template>
  <section class="content-section alts-section" :class="{ 'alts-section--compact': compact }">
    <div class="section-heading">
      <h2>{{ title }}</h2>
    </div>
    <div class="alts-scroll">
      <div class="alts-grid">
        <component
          :is="item.route ? 'router-link' : 'article'"
          v-for="item in items"
          :key="item.id"
          class="alt-card"
          :to="item.route ? { name: item.route } : null"
        >
          <img :src="item.icon" :alt="item.name + ' icon'" width="64" height="64">
          <h3>{{ item.name }}</h3>
          <p>{{ item.text }}</p>
        </component>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AlternativesGrid',
  props: {
    title: {
      type: String,
      default: 'Alternatives to GBWhatsApp',
    },
    items: {
      type: Array,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
